import styled from 'styled-components';
import Lab010 from 'dc/Lab010';
import { Typ32, Typ30 } from 'dc/Typ';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const DetailsWrapper = styled.div`
  margin-left: 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Typ32)`
  width: 100%;
  overflow: ellipsis;
  line-height: 22px;
`;

export const TitleWeak = styled(Typ30)`
  width: 100%;
  overflow: ellipsis;
  line-height: 22px;
  color: #5e6372;
`;

type Co2LabelProps = {
  $iconColor?: string;
};

export const Co2Label = styled(Lab010)<Co2LabelProps>`
  > i {
    color: ${props => props.$iconColor || '#00ab97'};
  }
`;
